export default __webpack_public_path__ + "static/media/imgPerfilHepatico.91039da2.png";